import type { CurrencyCode } from '@noths/polaris-dev-ts-types';

export const priceFormatter = (
  currency: CurrencyCode,
  amount: number,
  shouldConvertToDecimal = true,
) =>
  new Intl.NumberFormat('en-GB', {
    style: 'currency',
    currency,
    currencyDisplay: 'symbol',
    minimumFractionDigits: 2,
  })
    // Move decimal two places to the left.
    .format(shouldConvertToDecimal ? amount / 100 : amount)
    // Stripping out double zeros after the decimal place
    .replace(/\D00(?=\D*$)/, '')
    // Remove any alphabetical characters
    .replace(/[a-z]/gi, '');
